<ah-sidenav-filter [visible]="sidenav.visible" [allowDept]="allowDept" [allowProject]="allowProject" [tableType]="tableType" (toggleVisible)="sidenav.toggleVisible()" [width]="sidenav.width"
  [filters]="sidenav.filters" [assetShown]="assetTypesShown" (selectProject)="selectProject($event)" (select)="selectEntity($event)" [button]="true" buttonText="Trash Bin" (buttonClick)="viewTrash()">
</ah-sidenav-filter>
<mat-icon class="clickable toggle-margin sidenav-toggle" matTooltip="My Filters" (click)="sidenav.toggleVisible()" svgIcon="chevron_right"></mat-icon>
<div class="scroll-content scroll-content-sidenav-filter" [ngClass]="{'scroll-content-sidenav-filter-visible' : sidenav.visible}">
  <div class="header-container" ngClass.xs="mobile-table-header">
    <div class="index-title">
      <h1>{{ franchise?.name }} Assets</h1>
    </div>

    <!-- Only shows on Mobile -->
    <span class="mobile-title" [ngClass]="{ 'mobile-title-padding': currentView === assetIndexTypes.Default}">
    {{ currentView === assetIndexTypes.Default ? 'Assets' : 'For Review' }}</span>

    @if (canEdit) {
      <span class="header-container">
        <div style="margin-right: 1rem;">
          <mat-icon class="settings-icon clickable" svgIcon="settings" (click)="gotToAssetImportSettings()"></mat-icon>
        </div>
        <button mat-raised-button style="margin-right: 1rem;" (click)="gotToAssetImport()"
          ngClass.xs="mobile-button" matTooltip="Import Assets">
          Import Assets
        </button>
        @if (currentView === assetIndexTypes.Default) {
          <button class="import-btn" mat-raised-button
            (click)="openCreateDialog()" ngClass.xs="mobile-button" matTooltip="Create Assets">
            Create Assets
          </button>
        }
      </span>
    }
  </div>
  <ah-tab-bar [styleClass]="forReviewNotification ? 'notification-highlight' : ''" [tabs]="tabs" [activeTab]="activeTab"></ah-tab-bar>
  @if (selectedFields && selectedFields.length) {
    <ah-asset-data-table
      id="franchise_asset_index_default_table"
      [tableType]="tableType"
      [ngClass]="{ 'hide': currentView !== assetIndexTypes.Default}"
      [assets]="assets" [fields]="fields" [selectedProjectIdsList]="selectedProjectIdsList"
      [selectedFields]="selectedFields" [currentStudioId]="currentStudioId"
      [selectedFieldOptions]="selectedFieldOptions" [currentView]="currentView" [projectCurrencies$]="projectCurrencies$" [selectOptions]="selectOptions$ | async"
      (selectProjectCurrency)="selectProjectCurrency($event)" [selectedProjectCurrencyId]="selectedProjectCurrencyId"
      [assetDataService]="assetDataService" [columnFilterService]="columnFilterService" [assetTypesShown]="assetTypesShown"
      [user]="user" [allFieldOptions]="allFieldOptions" [franchise]="franchise" [ownedDivisions]="moveToDivisions"
      [dispositions$]="dispositions$" [bulkModalCharacters$]="bulkModalCharacters$" [bulkModalSets$]="bulkModalSets$"
      [updateCharSetOptions]="updateCharSetOptions" [locations$]="bulkModalLocations$" [departments]="departments$ | async" [departmentList]="departments$"
      (pageChanged)="getAssets($event)"
      (displayChanged)="clearAssetsCache($event)"
      (isAllSelected)="isAllAssetsSelcted($event)"
      (openCreateDialog)="openCreateDialog()" [hasBarcodeField]="hasBarcodeField" [indexType]="assetIndexTypes.Default" [allGroups$]="allGroups$" [franchiseGroups$]="franchiseGroups$" [notFranchiseGroups$]="notFranchiseGroups$" [stateKey]="defaultStateKey" (filterTableColumns)="filterTableColumns($event)" (sortTable)="sortTable($event)" [assetCountTotal]="assetCountTotal" (listAssetsAndFilters)="listAssetsAndFilters($event)" [assetEntities]="assetEntities" [filters]="filters"
      (exportAllCsvEvent)="exportAllCsvEvent()"
      >
    </ah-asset-data-table>
  }
  @if (selectedFields && selectedFields.length) {
    <ah-asset-data-table
      id="franchise_asset_index_for_review_table"
      [tableType]="tableType"
      [ngClass]="{'hide': currentView !== assetIndexTypes.ForReview}"
      [assets]="forReviewNotObs" [fields]="fields" [selectedProjectIdsList]="selectedProjectIdsList"
      [selectedFields]="selectedFields" [currentStudioId]="currentStudioId"
      [selectedFieldOptions]="selectedFieldOptions" [currentView]="currentView" [projectCurrencies$]="projectCurrencies$" [selectOptions]="selectOptionsForReview$ | async"
      (selectProjectCurrency)="selectProjectCurrency($event)" [selectedProjectCurrencyId]="selectedProjectCurrencyId"
      [assetDataService]="assetDataService" [columnFilterService]="columnFilterService" [assetTypesShown]="assetTypesShown"
      [user]="user" [allFieldOptions]="allFieldOptions" [showPillColumn]="true"
      [assetValidLookup]="assetValidLookup" [franchise]="franchise" [ownedDivisions]="moveToDivisions" [dispositions$]="dispositions$"
      [assetModalDataService]="assetModalDataService" [bulkModalCharacters$]="bulkModalCharacters$" [bulkModalSets$]="bulkModalSets$"
      [updateCharSetOptions]="updateCharSetOptions" [locations$]="bulkModalLocations$" [departments]="departments$ | async" [departmentList]="departments$"
      (pageChanged)="getForReviewAssets($event)"
      (displayChanged)="clearAssetsCache($event)"
      (openCreateDialog)="openCreateDialog()" [hasBarcodeField]="hasBarcodeField" [indexType]="assetIndexTypes.ForReview" [allGroups$]="allGroups$" [franchiseGroups$]="franchiseGroups$" [notFranchiseGroups$]="notFranchiseGroups$" [stateKey]="forReviewStateKey" (filterTableColumns)="filterTableColumns($event)" (sortTable)="sortTable($event)" [assetCountTotal]="assetCountForReviewTotal" (listAssetsAndFilters)="listAssetsAndFilters($event)" [filters]="filtersForReview"
      (exportAllCsvEvent)="exportAllCsvEvent()"
      (isAllSelected)="isAllAssetsSelectedForReview($event)">
    </ah-asset-data-table>
  }
</div>
